import React from "react";
var __jsx = React.createElement;
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { ELSLink } from "components/common/elsevier/Link/Link";
import { selectUsersessionData } from "../../../../redux/reducers/userSessionReducer";
import GlobalHeaderProduct from "./GlobalHeaderProduct";
import globalHeaderStyles from "./GlobalHeader.module.scss";
var GlobalHeaderNavigation = dynamic(function () {
  return import("./GlobalHeaderNavigation");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./GlobalHeaderNavigation")];
    }
  }
});
export default function GlobalHeader(_ref) {
  var _ref$isPublic = _ref.isPublic,
    isPublic = _ref$isPublic === void 0 ? false : _ref$isPublic,
    _ref$beta = _ref.beta,
    beta = _ref$beta === void 0 ? process.env.NEXT_PUBLIC_BETA_MODE === "true" : _ref$beta;
  var userSession = useSelector(selectUsersessionData);
  return /*#__PURE__*/React.createElement("header", {
    id: "es-global-header",
    className: globalHeaderStyles["es-global-header"]
  }, /*#__PURE__*/React.createElement(ELSLink, {
    href: "#maincontent",
    className: "sr-only kb-enabled"
  }, "Skip to main content"), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    alignItems: "center",
    className: globalHeaderStyles["es-global-header__parent"]
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    className: globalHeaderStyles["es-global-header__parent--logo"]
  }, /*#__PURE__*/React.createElement(GlobalHeaderProduct, null), " "), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    item: true,
    alignItems: "center",
    justifyContent: "flex-end",
    xs: true
  }, !isPublic && (userSession === null || userSession === void 0 ? void 0 : userSession.auth) && /*#__PURE__*/React.createElement(GlobalHeaderNavigation, {
    beta: beta
  }))));
}